module.exports = __webpack_public_path__ + "static/media/go_lecture_pop_up.71cc6f83.png";